export default __webpack_public_path__ + "static/media/1_0108.6ee6b3e1.webp";